import firebase from 'firebase';
import { AppDispatch } from '../../store';
import {
  restaurantUpdated,
  restaurantListenerError,
  resetRestaurant,
} from './restaurant.slice';
import { COLLECTIONS } from '../../constants/data';
import { serializeRestaurantSnap } from './restaurant.service';

let unsubscribe: firebase.Unsubscribe | null = null;
let activeRestaurantId: string | null = null;

export const syncRestaurantListener = (
  restaurantId: string | null,
  dispatch: AppDispatch
) => {
  console.log(`syncRestaurantListener from [${activeRestaurantId}] to [${restaurantId}]`);
  // No-op if the same ID is already active
  if (restaurantId === activeRestaurantId) return;

  // Tear down any existing listener
  if (unsubscribe) {
    unsubscribe();
    unsubscribe = null;
  }

  activeRestaurantId = restaurantId;

  // If called with null, just reset state and stop
  if (!restaurantId) {
    dispatch(resetRestaurant());
    return;
  }

  unsubscribe = firebase
    .firestore()
    .collection(COLLECTIONS.restaurants)
    .doc(restaurantId)
    .onSnapshot(
      (snapshot) => {
        if (!snapshot.exists) return;
        dispatch(restaurantUpdated(serializeRestaurantSnap(snapshot)));
      },
      (error) => {
        console.error(error);
        dispatch(restaurantListenerError(error.message));
        // Reset tracking so a retry is possible
        activeRestaurantId = null;
        unsubscribe = null;
      }
    );
};